import { hexToRgb } from '@material-ui/core';

const hexRgbToValues = (hex: string): string => {
  const rgb = hexToRgb(hex);
  if (rgb.includes('rgba')) {
    return rgb ? rgb.slice(rgb.indexOf('(') + 1, rgb.lastIndexOf(',')) : '';
  }
  return rgb ? rgb.slice(rgb.indexOf('(') + 1, rgb.indexOf(')')) : '';
};

const removeRGBKeys = (colorState: any) => {
  const colors: any = {};
  for (const key in colorState) {
    if (!key.includes('RGB')) {
      colors[key] = colorState[key];
    }
  }
  return colors;
};
const convertColorsToRGB: (colorState: any) => string[] = (colorState) => {
  const oldColors = removeRGBKeys(colorState);
  const colors: any = {};
  for (const key in oldColors) {
    colors[key] = oldColors[key];
    if (typeof oldColors[key] === 'string') {
      colors[`${key}RGB`] = hexRgbToValues(oldColors[key]);
    }
  }
  return colors;
};
export { convertColorsToRGB };
